import { useContext, useState } from 'react'
import { Bug, Loader2 } from 'lucide-react'
import { SidebarMenuButton } from '@/components/ui/sidebar'
import {
    NAV_LUCIDE_SIZE_CLASS,
    NAV_LUCIDE_STROKE,
} from '@/components/navigation/navIconConstants'
import {
    ReportIssueModal,
    captureViewportScreenshot,
} from '@/components/support/ReportIssueModal'
import { SidebarNavRow } from './SidebarNavRow'
import { cn } from '@/lib/utils'
import { AuthContext } from '@/modules/auth/authContext'

export function NavReportIssue() {
    const { user, client } = useContext(AuthContext)
    const [isOpen, setIsOpen] = useState(false)
    const [isCapturing, setIsCapturing] = useState(false)
    const [screenshot, setScreenshot] = useState<string | null>(null)

    const handleOpen = async () => {
        setIsCapturing(true)
        // Capture before the dialog mounts — it portals onto document.body,
        // so capturing after opening it would photograph the dialog itself.
        const captured = await captureViewportScreenshot()
        setScreenshot(captured)
        setIsCapturing(false)
        setIsOpen(true)
    }

    return (
        <>
            <SidebarMenuButton
                variant="nav"
                size="nav"
                type="button"
                onClick={handleOpen}
                disabled={isCapturing}
                className="truncate"
            >
                <SidebarNavRow
                    icon={
                        isCapturing ? (
                            <Loader2
                                className={cn(
                                    NAV_LUCIDE_SIZE_CLASS,
                                    'animate-spin',
                                )}
                                strokeWidth={NAV_LUCIDE_STROKE}
                                aria-hidden
                            />
                        ) : (
                            <Bug
                                className={NAV_LUCIDE_SIZE_CLASS}
                                strokeWidth={NAV_LUCIDE_STROKE}
                                aria-hidden
                            />
                        )
                    }
                >
                    {isCapturing ? 'Preparing...' : 'Report an Issue'}
                </SidebarNavRow>
            </SidebarMenuButton>
            <ReportIssueModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                userEmail={user?.username || ''}
                clientName={client?.name}
                shopName={client?.shopifyShop}
                screenshot={screenshot}
            />
        </>
    )
}
